import React from 'react'

export default function Banner() {
    return (
        <section className="w3l-banner-3-main">
            <div className="banner-3">
                <div className="wrapper">
                    <div className="cover-top-center-9">
                        <div className="w3ls_cover_txt-9">

                            <h3 className="title-cover-9">
                                Shop Local. Join the Network. Earn Rewards.
                            </h3>

                            <p className="para-cover-9">
                                Discover local businesses, shop through the DLMP21 network,
                                and participate in a customer reward ecosystem built around
                                your everyday purchases.
                            </p>

                            <p className="para-cover-9">
                                <strong>
                                    Register → Shop ₹1,000+ → Show Your DLMP Code →
                                    Track Your Rewards
                                </strong>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}